import { KeyPair } from 'near-api-js'
import { ec } from 'elliptic'
import { keccak256 } from 'js-sha3'
import { LOCAL_STORAGE_KEYCHAIN } from '@/constants/config'

const secp256k1 = new ec('secp256k1')

// window.KeyPair = KeyPair
// window.Buffer = Buffer
// window.keccak256 = keccak256
// window.secp256k1 = secp256k1

// URLSAFE Base64 (RFC4648, the '+' and '/' changed to '-' and '_' )
function urlSafeBase64(base64) {
  return base64.replace(/\+/g, '-').replace(/\//g, '_')
}

function parseApiKeychainString(s) {
  const { accountId, orderlyKey, orderlyTradingKey } = JSON.parse(atob(s))
  return {
    accountId,
    orderlyKeyPair: KeyPair.fromString(orderlyKey),
    orderlyTradingKeyPair: secp256k1.keyFromPrivate(orderlyTradingKey),
    orderlyTradingSecret: orderlyTradingKey
  }
}

export function getKeychainString() {
  return localStorage.getItem(LOCAL_STORAGE_KEYCHAIN)
}

export function parseKeychainString(s) {
  const { accountId, orderlyKey, orderlyTradingKey } = JSON.parse(atob(s))
  return {
    accountId,
    orderlyKeyPair: KeyPair.fromString(orderlyKey),
    orderlyTradingKeyPair: secp256k1.keyFromPrivate(orderlyTradingKey)
  }
}

export function getOrderlyKey(orderlyKeyPair) {
  return orderlyKeyPair.getPublicKey().toString()
}

export function getOrderlyTradingKey(orderlyTradingKeyPair) {
  return orderlyTradingKeyPair.getPublic().encode('hex').replace('04', '')
}

export function getOrderSignature(orderlyTradingKeyPair, dataParametersString) {
  const messageHash = keccak256(Buffer.from(dataParametersString))
  const orderSignature = orderlyTradingKeyPair.sign(messageHash)
  const r = orderSignature.r.toString('hex', 64)
  const s = orderSignature.s.toString('hex', 64)
  return `${r}${s}0${orderSignature.recoveryParam}`
}

export function getRequestSignature(
  orderlyKeyPair,
  {
    timestamp,
    requestMethod = '',
    requestPath = '',
    queryString = '',
    dataString = ''
  }
) {
  const signature = orderlyKeyPair.sign(
    Buffer.from(
      `${timestamp}${requestMethod}${requestPath}${queryString}${dataString}`
    )
  ).signature
  return urlSafeBase64(Buffer.from(signature).toString('base64'))
}

export function getApiTradingKeyInfo() {
  const keychainString = getKeychainString()
  const {
    accountId,
    orderlyKeyPair,
    orderlyTradingKeyPair,
    orderlyTradingSecret
  } = parseApiKeychainString(keychainString)
  return {
    accountId,
    orderlyApiKey: getOrderlyKey(orderlyKeyPair),
    orderlyApiSecret: orderlyKeyPair.toString(),
    orderlyTradingApiKey: getOrderlyTradingKey(orderlyTradingKeyPair),
    orderlyTradingSecret
  }
}
